import { Alert } from "@material-ui/lab";

import { incrementDataRevision } from "app/store/tools/revisionSlice";

const opsExceptionStatusForm = {
	urlGET: "api/profile/carriers/:carrierId/ops-exceptions/:id",
	urlDELETE: "api/profile/carriers/:carrierId/ops-exceptions/:id/status/:status",
	idKey: "_id",
	triggerEvent: ["opsExceptionRevision", "dataRevision"],
	listenEvent: "opsExceptionRevision",
	header: {
		delete: { label: "Change Exception Status" },
	},
	content: {
		delete: {
			items: [
				{
					type: "message",
					builder: (item, dataIds) => {
						const { status } = dataIds || {};

						// Handle active/inactive status changes
						if (status === "active" || status === "inactive") {
							return (
								<span className="ml-5">
									Would you like to {status === "inactive" ? "archive" : "activate"} exception '{item.title}'?
								</span>
							);
						}

						// Handle workflow status changes
						const statusMessages = {
							"In Progress": "mark this exception as In Progress",
							Resolved: "mark this exception as Resolved",
							Closed: "close this exception",
						};

						return (
							<div>
								{status === "Resolved" && (
									<Alert className="flex flex-row w-full mb-16" severity="success">
										Marking this exception as Resolved will set the resolution date to now.
									</Alert>
								)}
								{status === "Closed" && item.status !== "Resolved" && (
									<Alert className="flex flex-row w-full mb-16" severity="warning">
										It's recommended to resolve exceptions before closing them.
									</Alert>
								)}
								<span className="ml-5">
									Would you like to {statusMessages[status] || `change status to ${status}`} '{item.title}'?
								</span>
							</div>
						);
					},
				},
				{
					type: "group",
					content: {
						items: [
							{ type: "action", action: "CANCEL" },
							{ type: "action", action: "DELETE", label: "Continue" },
						],
					},
				},
			],
			onFinished: (_, dispatch) => {
				dispatch(incrementDataRevision({ event: "profileRevision" }));
				dispatch(incrementDataRevision({ event: "opsExceptionRevision" }));
			},
		},
	},
};

export default opsExceptionStatusForm;
